import React from "react";
import "./ui.css";

export default function Card({ title, children, className = "", style }) {
  const classes = className ? `ui-card ${className}` : "ui-card";
  return (
    <div className={classes} style={style}>
      {title ? <div className="ui-card__title">{title}</div> : null}
      <div className="ui-card__body">{children}</div>
    </div>
  );
}
